import * as Icons from '@/assets/features/auth'
import { Outlet } from 'react-router-dom'
import React, { Suspense } from 'react'
import SelectLanguages from '@/components/shared/inputs/SelectLanguages'

export default function AuthLayout({ children }) {
  return (
    <div
      className="relative min-h-screen flex items-center justify-center 
        bg-[linear-gradient(180deg,_#3927514d_0%,_#80808000_100%)]
        bg-no-repeat bg-transparent font-poppins"
    >
      <div className="absolute right-4 top-4 z-10 [&_button]:rounded-2xl">
        <SelectLanguages />
      </div>
      <div
        className="w-full shadow-[0_0_50px_0_rgba(42,45,48,0.2)]
          max-w-[400px] bg-[#f6f6f6] px-[45px] py-[5px] rounded-md"
      >
        <img
          src={Icons.FullLogo}
          className="h-20 relative right-6"
          alt="Talentino Logo"
        />
        <hr className="mt-0 bg-[#9a9a9a] h-0.5" />
        <Outlet />
      </div>
    </div>
  )
}
